
import foot_component from './foot-component.vue'
import head_component from './head-component.vue'
import popup from './popup.vue'
import breadcrumb from './bread-crumb.vue'
import toast from './toast.vue'
import smActivity from './smActivity.vue'



function plugins(Vue){
  
  Vue.component("foot-component",foot_component);
  Vue.component("head-component",head_component);
  Vue.component("popup",popup);
  Vue.component("breadcrumb",breadcrumb);
  Vue.component("toast",toast);
  Vue.component("smActivity",smActivity);


}
export default plugins;


// WEBPACK FOOTER //
// ./src/components/plugins/index.js